import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Carousel from '../components/Carousel';
import Footer from '../components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import cashew from '../assets/banners/cashew.jpg';
import almonds from '../assets/banners/almonds.jpg';
import spices from '../assets/banners/spices.jpg';
import basmati from '../assets/banners/basmati.jpg';
import cardamons from '../assets/banners/cardamons.jpg';
import blackPepper from '../assets/banners/black-pepper.avif';

const topProducts = [
    { title: 'Premium Cashews', image: cashew },
    { title: 'Raw Almonds', image: almonds },
    { title: 'Mixed Spices', image: spices },
    { title: 'Basmati Rice', image: basmati },
];

const categories = [
    { title: 'Cashews', image: cashew, link: '/product/cashew' },
    { title: 'Almonds', image: almonds, link: '/product/almonds' },
    { title: 'Black Pepper', image: blackPepper, link: '/product/black-pepper' },
    { title: 'Garam Masala', image: spices, link: '/product/garam-masala' },
    { title: 'Cardamons', image: cardamons, link: '/product/cardamons' },
    { title: 'Basmati', image: basmati, link: '/product/basmati-rice' },
];

const Home = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <div className="text-gray-800 bg-white">
            <Carousel />

            {/* Top Products Section */}
            <section className="max-w-6xl mx-auto px-4 py-12">
                <h2 className="text-3xl font-bold text-center text-yellow-600 mb-10" data-aos="fade-up">
                    Our Top Products
                </h2>
                <div className="grid md:grid-cols-4 sm:grid-cols-2 gap-6" data-aos="fade-up">
                    {topProducts.map((item, idx) => (
                        <div
                            key={idx}
                            className="bg-white shadow-md hover:shadow-xl rounded-lg overflow-hidden transition-transform transform hover:-translate-y-1"
                            data-aos="zoom-in"
                        >
                            <img
                                src={item.image}
                                alt={item.title}
                                className="w-full h-48 object-cover"
                            />
                            <div className="p-4 text-center">
                                <h3 className="font-semibold text-lg text-gray-700">{item.title}</h3>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* Product Categories Section */}
            <section className="bg-yellow-50 py-12" data-aos="fade-up">
                <div className="max-w-6xl mx-auto px-4">
                    <h2 className="text-3xl font-bold text-center text-yellow-700 mb-10">Product Categories</h2>
                    <div className="grid md:grid-cols-3 sm:grid-cols-2 gap-8">
                        {categories.map((cat, idx) => (
                            <Link
                                to={cat.link}
                                key={idx}
                                className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition duration-300 block"
                                data-aos="fade-up"
                            >
                                <img
                                    src={cat.image}
                                    alt={cat.title}
                                    className="w-full h-40 object-cover rounded-lg mb-4"
                                />
                                <h4 className="text-lg font-semibold text-gray-700 text-center">{cat.title}</h4>
                            </Link>
                        ))}
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default Home;
